



































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { enums } from '@/common/enums';
import DataPanel from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import PaginationPanel from '@/components/PaginationPanel.vue';
import { DraggerImg } from '@/components';
import BaseContainer from '@/components/BaseContainer.vue';
import { OperateLog } from '@/http';
import collapse from '../../utils/collapse';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: { DataPanel, PaginationPanel, BaseContainer, collapse, PageDescribe, SearchPanel, DraggerImg },
})
export default class LogsInfo extends Vue {
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };
    public isStatusType = enums.isStatusType;
    public isActive: boolean = false;
    public rePagin: boolean = false;
    public total: number = 0;
    public labelPosition: string = 'right';
    public logModuleEnum = enums.logModuleEnum;
    public searchValue: any = {
        module: null,
        code: '',
    };
    public loading: boolean = false;
    public listData = [];

    mounted() {
        this.$refs.draggerImg.imgdrager();
        this.loadDataList();
    }
    public defaultProps = {
        label: (data, node) => {
            return data.name ? data.name : data.userName;
        },
        children: 'childrenList',
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        this.loadDataList();
    }
    public async loadDataList() {
        this.loading = true;
        await OperateLog.GetOperateLogList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.listData = res.data;
                let skip = this.searchPagin.skip;
                this.listData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    public search() {
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
    public reset() {
        this.searchValue = {
            module: null,
            code: '',
        };
        this.loadDataList();
    }
    tableRowClassName({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
            return '';
        }
        return 'success-row';
    }
}
